<div class="provider-item">
    <div class="left-part">{{itemData.name}}</div>
    <div class="right-part">{{getDSTypeName(itemData.type)}}</div>
</div>
